export default {"src":"/_next/static/media/popeyes-error.27880de0.svg","height":313,"width":207,"blurWidth":0,"blurHeight":0};